import cx from 'classnames';
import { useController } from "react-hook-form";
import styles from './ButtonListController.module.scss';

export const ButtonListController = ({ options, control, name, label }) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  });

  return (
    <>
      {label}
      <div className={cx(styles.rotaionBox, 'mb-3')}>
        {options.map((option) => {
          const selected = option.value === value;
          return (
            <button
              value={option.value}
              key={option.value}
              onClick={() => onChange(option.value)}
              type="button"
              className={cx('btn', selected && 'btn-selected')}>
              {option.label}
            </button>
          );
        })}
      </div>
    </>
  );
};
